// Employee Payrate type
export const payrateTypes = [
  { value: 0, label: "Unknown", code: "U" },
  { value: 1, label: "Salary", code: "S" },
  { value: 2, label: "Hourly", code: "H" },
];

export const getPayRateTypeLabel = (incoming) => {
  return payrateTypes.find(v => v.value === incoming)?.label;
};